<template>
  <div
    class="h-100 p-10 position-absolute"
    :style="{ height: height, top: top }"
    id="AddDeviceModel"
  >
    <div class="form_header">
      <div class="form_header_title">
        <el-row>
          <el-col :span="21">
            <span class="fz-14">新增模型</span>
          </el-col>
          <el-col :span="3" class="tr">
            <span class="iconfont r cur_pointer icon-close fz-12" @click="closeComponent"></span>
          </el-col>
        </el-row>
      </div>
      <div class="select_part w-100">
        <el-select
          ref="classfiySelectTree"
          popper-class="document_select-popper"
          value-key=""
          clearable
          filterable
          class="w-100"
          size="small"
          @clear="resetDeviesInfo"
          v-model="devicesInfo.pathName"
          placeholder="分类"
        >
          <el-option :label="devicesInfo.pathName" :value="devicesInfo.pathName">
            <el-tree
              :props="{
                label: 'name',
                children: 'children',
              }"
              node-key="id"
              highlight-current
              :lazy="true"
              :load="loadNode"
              @node-click="classfiyNodeClick"
              :expand-on-click-node="false"
            ></el-tree>
          </el-option>
        </el-select>
      </div>
      <el-row type="flex" align="middle" class="m-t-5">
        <el-col :span="21"
          ><el-input placeholder="名称搜索" v-model="typeKeyWords" clearable size="small"></el-input
        ></el-col>
        <el-col :span="3" class="tr">
          <el-tooltip effect="dark" content="搜索" placement="top">
            <el-button
              type="primary"
              size="small"
              class="iconfont icon-search"
              @click="getComponentList"
            ></el-button>
          </el-tooltip>
        </el-col>
      </el-row>
    </div>
    <div class="form_body">
      <div class="card_list">
        <div class="card" v-for="(item, index) in listData" :key="index">
          <div class="card_img">
            <img :src="`${currentEnv.VUE_APP_PLANT_SERVER}${item.thumbnails}`" />
          </div>
          <div
            class="card_text"
            @click="
              (e) => {
                e.stopPropagation()
              }
            "
          >
            <el-checkbox v-model="item.select" class="d-flex flex-align-center">{{
              item.name
            }}</el-checkbox>
          </div>
        </div>
      </div>
    </div>
    <div
      class="form_bottom w-100 d-flex flex-align-center flex-row-between"
      @click="
        (e) => {
          e.stopPropagation()
        }
      "
    >
      <el-radio-group v-model="addType" class="d-flex flex-align-center">
        <el-radio size="small" :label="1">锚点位置</el-radio>
        <el-radio size="small" :label="2">按节点</el-radio>
      </el-radio-group>
      <el-select
        v-model="localValue"
        placeholder="中心"
        size="mini"
        popper-class="document_select-popper"
      >
        <el-option
          v-for="item in location"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        >
        </el-option>
      </el-select>
      <el-button type="primary" size="mini" @click="createdNewModel">新增</el-button>
    </div>
    <!-- 模型进度条 -->
    <player-progress
      :loadType="loadType"
      :percentage="loadPercentage"
      v-if="showLoadProgress"
    ></player-progress>
  </div>
</template>
<script>
import DocumentManagementService from '@/services/documentManagement'
import ApiMixinDocuments from '@/assets/js/api/documents'
import ApiMixinDocumentList from '@/assets/js/api/documentList'
import { loadFbxModel, loadPrModel } from '../../js/engineerSceneData'

const PlayerProgress = () => {
  return import('@/components/model/PlayerProgress')
}
export default {
  components: {
    PlayerProgress,
  },
  name: 'AddDeviceModel',
  props: ['documentId', 'player', 'height', 'top', 'currentNodeData'],
  mixins: [ApiMixinDocuments, ApiMixinDocumentList],
  computed: {
    currentProject() {
      return this.$store.getters.currentProject || this.$store.getters['Sites/currentProject'] || {}
    },
    DevicesLibrariesFolder() {
      const path = _.find(this.systemParams, { parameterCode: 'DevicesLibrariesFolder' }) || {}
      return path.parameterValue || null
    },
    DevicesClassId() {
      const parameter = _.find(this.systemParams, { parameterCode: 'DevicesClass' }) || {}
      return parameter ? parameter.parameterValue : ''
    },
  },
  async created() {
    await this.getAttributeTemplateList()
    await this.getCurrentFolderId()
    this.getTypeList()
  },
  methods: {
    /* 加载模型相关start */

    /**
     * @description: 检查是否模型是否存在 不存在则下载
     * @param {*}
     * @return {*}
     */
    async checkModel(modelParams) {
      const currentModelFile = _.find(modelParams, (item) => {
        return item.fileType === '.pr' || item.fileType === '.fbx'
      })
      if (!currentModelFile) {
        this.$message.error('当前项目没有模型')
        return
      }
      const currentZip = _.find(modelParams, ['fileType', '.zip'])
      if (currentZip) {
        this.checkModelMaterial(currentZip, currentModelFile)
      } else {
        this.getCurrentModelFile(currentModelFile, {})
      }
    },

    // 检查模型材质文件
    async checkModelMaterial(item, modelParams) {
      // eslint-disable-next-line no-await-in-loop
      const result = await this.player.Native.File.getFileMd5(
        `data://../apps/${currentEnv.VUE_APP_CURRENT_PROJECT}/models/${modelParams.md5}/${modelParams.md5}.zip`
      )
      const exists = await this.player.Native.File.exists(
        `data://../apps/${currentEnv.VUE_APP_CURRENT_PROJECT}/models/${modelParams.md5}/${modelParams.md5}.zip`
      )
      if (item.md5 === result && exists) {
        this.getCurrentModelFile(modelParams, item)
      } else {
        this.downloadMaterialFile(item.md5, item, modelParams)
      }
    },

    // 检查模型是否存在
    getCurrentModelFile(item, materialParams) {
      this.player.Native.File.getFileMd5(
        `data://../apps/${currentEnv.VUE_APP_CURRENT_PROJECT}/models/${item.md5}/${item.md5}${item.fileType}`,
        (res) => {
          if (res === item.md5) {
            // 有模型就加载模型
            this.addModel(
              item.md5,
              `data://../apps/${currentEnv.VUE_APP_CURRENT_PROJECT}/models/${item.md5}/${item.md5}${item.fileType}`,
              item,
              materialParams
            )
          } else {
            // 校验md5失败
            this.downloadFile(item.md5, item.fileType, item, materialParams)
          }
        }
      )
    },

    // 下载材质文件
    async downloadMaterialFile(md5, item, modelParams) {
      this.player.Native.File.EventDownloadProcessChanged.connect(this.progressMsg)
      this.player.Native.File.EventDownloadFinish.connect(
        this.downloadMaterialMsg(modelParams.md5, item, modelParams)
      )
      const res = await this.player.Native.File.downloadFile(
        `data://../apps/${currentEnv.VUE_APP_CURRENT_PROJECT}/models/${modelParams.md5}/${modelParams.md5}.zip`,
        'GET',
        `${currentEnv.VUE_APP_PLANT_SERVER}/api/documentfile/getfilecontentasync/${md5}`,
        { Authorization: `${this.fullToken}` }
      )
      // 代表创建下载任务成功
      if (res) {
        this.showLoadProgress = true
        this.loadType = '下载中...'
      } else {
        this.$message.warning('下载材质文件失败')
      }
    },

    /**
     * @description: 下载模型
     * @param {*} playerName：模型名称
     * @param {*} type： 模型类型
     * @return {*}
     */
    async downloadFile(md5, type, item, materialParams) {
      this.player.Native.File.EventDownloadProcessChanged.connect(this.progressMsg)
      this.player.Native.File.EventDownloadFinish.connect(
        this.downloadMsg(md5, item, type, materialParams)
      )
      this.player.Native.File.downloadFile(
        `data://../apps/${currentEnv.VUE_APP_CURRENT_PROJECT}/models/${md5}/${md5}${type}`,
        'GET',
        `${currentEnv.VUE_APP_PLANT_SERVER}/api/documentfile/getfilecontentasync/${md5}`,
        { Authorization: `${this.fullToken}` },
        (res) => {
          // 代表创建下载任务成功
          if (res) {
            this.showLoadProgress = true
            this.loadType = '下载中...'
          } else {
            this.$message.warning('下载模型失败')
          }
        }
      )
    },
    // 监听下载模型是否成功
    downloadMsg(md5, item, type, materialParams) {
      const _this = this
      const fun = async (file, err) => {
        _this.loadPercentage = 0
        _this.showLoadProgress = false
        if (err) {
          _this.$message.warning(`下载文件失败，${file}, ${err}`)
          return
        }
        if (
          file ===
          `data://../apps/${currentEnv.VUE_APP_CURRENT_PROJECT}/models/${md5}/${md5}${type}`
        ) {
          _this.player.Native.File.EventDownloadFinish.disconnect(fun) // 断开下载
          _this.player.Native.File.EventDownloadProcessChanged.disconnect(_this.progressMsg)
          // 检查当前md5和远程下载的md5是否一致
          _this.player.Native.File.getFileMd5(
            `data://../apps/${currentEnv.VUE_APP_CURRENT_PROJECT}/models/${md5}/${md5}${type}`,
            (res) => {
              if (res !== md5) {
                _this.$message.warning('当前请求的md5和服务器下载的md5不一致！')
              }
            }
          )
          _this.addModel(md5, file, item, materialParams) // 模型下载成功就加载模型
        }
      }
      return fun
    },

    // 监听下载模型是否成功
    downloadMaterialMsg(md5, item, modelParams) {
      const that = this
      const fun = async (file, err) => {
        that.showLoadProgress = false
        that.loadPercentage = 0
        if (err) {
          that.$message.warning(`下载材质文件失败，${file}, ${err}`)
          return
        }
        if (
          file === `data://../apps/${currentEnv.VUE_APP_CURRENT_PROJECT}/models/${md5}/${md5}.zip`
        ) {
          that.player.Native.File.EventDownloadFinish.disconnect(fun) // 断开下载
          that.player.Native.File.EventDownloadProcessChanged.disconnect(that.progressMsg)
          await this.player.Native.UiQt.decompressingZIP(file, '')
          setTimeout(() => {
            that.getCurrentModelFile(modelParams, item)
          }, 1500)
        }
      }
      return fun
    },

    // 监听下载进度
    progressMsg(file, bytesReceived, bytesTotal) {
      if (bytesTotal) {
        this.loadPercentage = (bytesReceived / bytesTotal) * 100
      }
    },
    checkModelLoad(data) {
      this.loadType = '加载中...'
      this.showLoadProgress = true
      this.loadPercentage = data * 100
    },
    /**
     * @description: 监听模型加载完成
     * @param {*} data
     * @return {*}
     */
    checkModelLoadEnd(data) {
      this.showLoadProgress = false
      this.player.Native.Model.EventProgress.disconnect(this.checkModelLoad)
      this.player.Native.Model.EventProgressEnd.disconnect(this.checkModelLoadEnd)
    },
    // 加载模型
    async addModel(md5, url, item, materialParams) {
      this.player.Native.Model.EventProgress.connect(this.checkModelLoad)
      this.player.Native.Model.EventProgressEnd.connect(this.checkModelLoadEnd)
      const rootItems = await this.player.Native.ModelTree.getRootItems()
      const currentRoot = _.find(rootItems, (val) => {
        return val.code && JSON.parse(val.code) && JSON.parse(val.code).type === 'Root'
      })
      const rootNode =
        !_.isNil(currentRoot) && currentRoot.nodePtr
          ? currentRoot.nodePtr
          : await this.player.Native.NodeProxy.rootNode()
      let currentNode = null
      if (item.fileType === '.pr') {
        currentNode = await loadPrModel(
          url,
          item.documentName,
          this.currentNodeData.nodePtr || rootNode,
          this.player
        ) // 加载模型
      } else if (item.fileType === '.fbx') {
        const parentNode = this.currentNodeData.nodePtr ? this.currentNodeData.nodePtr : rootNode
        currentNode = await loadFbxModel(url, item.documentName, parentNode, this.player)
      } else {
        currentNode = await this.player.Native.NodeProxy.loadModelNode(
          this.currentNodeData.nodePtr || rootNode,
          url,
          item.documentName
        ) // 加载模型
      }
      await this.player.Native.NodeProxy.setGlobalTranslation(currentNode, this.pos)
      await this.player.Native.NodeProxy.setNodeInfo(currentNode, {
        code: JSON.stringify({
          type: 'EngineerChildNode',
          fileType: item.fileType,
          filePath: url,
          documentId: item.documentId,
          md5,
          materialFileMd5: materialParams.md5,
        }),
      })
      this.checkList = []
      this.fileId = []
      this.$emit('updateEditTree', currentNode)
    },

    /**


    /* 加载模型相关end */
    /* ---------- 类别路径选择相关 start---------- */
    classfiyNodeClick(node) {
      this.devicesInfo.FolderId = node.id
      this.devicesInfo.pathName = node.pathName ? node.pathName : node.name
      this.$refs.classfiySelectTree.blur()
      this.getComponentList()
    },
    // 清空筛选
    resetDeviesInfo() {
      this.devicesInfo.FolderId = ''
      this.devicesInfo.pathName = ''
    },
    /**
     * @description: 类别树懒加载
     * @param {*} node
     * @param {*} resolve
     * @return {*}
     */

    async loadNode(node, resolve) {
      if (node.level === 0) {
        const res = await this.apiFolder({
          method: 'folderDetail',
          params: {
            folderId: this.DevicesLibrariesFolder,
          },
        })
        if (res && res.success && res.data) {
          res.data.pathName = res.data.path + res.data.name
          return resolve([res.data])
        }
        return resolve([])
      }
      const folderTree = await this.getFolderById(node.key, 1, 2)
      return resolve(folderTree)
    },
    /**
     * @description: 获取文档路径树结构
     * @param {*} folderId 文件id
     * @param {*} type (1：下一级  2：所在层往上的树列表)
     * @param {*} flag (0：老目录  2：移交目录)
     * @param {*} isPermisstion (是否加文件夹权限限制)
     * @return {*}
     */

    async getFolderById(folderId, type, flag, isPermisstion) {
      const res = await DocumentManagementService.getDocPathByFolderId({
        siteId: this.currentProject.id,
        folderId,
        type,
        flag,
        userId: this.userInfo.sub,
        isPermisstion: _.isNil(isPermisstion) ? true : isPermisstion,
      })
      if (res && res.code === 0 && !_.isNil(res.data)) {
        return this.disposeTree(res.data, 'children')
      }
      return []
    },
    disposeTree(treeData, key, parent) {
      const resData = _.map(treeData, (item) => {
        item.pathId = parent ? `${parent.pathId}/${item.id}` : `/${item.id}`
        if (item[key].length) {
          item.children = this.disposeTree(item[key], key, item)
        }
        return item
      })
      return resData
    },
    // 获取类型列表
    async getTypeList() {
      const res = await DocumentManagementService.getDocumentTree({
        siteId: this.currentProject.id,
        flag: 2,
        parentId: this.currentFolderId,
      })
      if (res && res.data && res.code === 0) {
        this.typeList = res.data
      }
    },
    /**
     * @description: 获取属性模板
     * @return {*}
     */

    async getAttributeTemplateList() {
      const res = await DocumentManagementService.getTemplateByClassId({
        classId: this.DevicesClassId,
      })
      if (res && res.code === 0 && res.data) {
        if (res.data.templateAttrSetList) {
          this.dialogInfo.templateAttrSetList = _.cloneDeep(res.data.templateAttrSetList)
        }
      }
    },
    // 模型点击事件
    async createdNewModel() {
      if (this.addType === 1) {
        const proxy = await this.player.Native.Camera.getAnchorPos()
        this.pos = proxy
      } else if (this.addType === 2) {
        if (this.currentNodeData.item) {
          const calcData = await this.player.Native.ModelTree.calcItemAabbData(
            this.currentNodeData.item
          )
          this.pos = Aabb.faceCenter(calcData.aabb, this.localValue)
        } else {
          this.$message.warning('请选择节点')
          return
        }
      }
      const checkList = _.filter(this.listData, ['select', true])
      for (let i = 0; i < checkList.length; i++) {
        this.getProxyInfo(checkList[i].id)
      }
      _.forEach(this.listData, (item) => {
        item.select = false
      })
    },
    // 获取锚点信息
    async getProxyInfo(val) {
      const res = await DocumentManagementService.getFileList({
        id: val,
      })
      if (res && res.data) {
        this.modelParams = res.data
        this.checkModel(this.modelParams)
        console.log(this.modelParams)
      }
    },
    // 获取加载ID
    async getCurrentFolderId() {
      const res = await this.apiFolder({
        method: 'folderDetail',
        params: {
          folderId: this.DevicesLibrariesFolder,
        },
      })
      this.currentFolderId = res.data.id
      this.getComponentList()
    },
    // 加载元件列表
    async getComponentList() {
      const query = {
        folderId: this.devicesInfo.FolderId ? this.devicesInfo.FolderId : this.currentFolderId,
        pageno: 1,
        pagesize: 1000,
        keyWord: this.typeKeyWords,
      }
      // 拼接属性模板搜索条件
      // if (this.dialogInfo.templateAttrSetList) {
      //   const attrValue = _.find(
      //     this.dialogInfo.templateAttrSetList[0].attrValueList,
      //     (attrValue) => {
      //       return attrValue.attrbuteDetail.displayName === '型号'
      //     }
      //   )
      //   query.searchItems = [
      //     {
      //       tableName: this.dialogInfo.templateAttrSetList[0].tableName,
      //       tableItems: [
      //         {
      //           fieldName: attrValue.fieldName,
      //           fieldValue: this.typeKeyWords,
      //           valueType: attrValue.valueType,
      //         },
      //       ],
      //     },
      //   ]
      // }
      const res = await DocumentManagementService.advancedSearch(query)
      if (res && res.code === 0 && res.data) {
        this.listData = _.map(res.data.items, (item) => {
          return {
            ...item,
            select: false,
          }
        })
      }
    },
    // 关闭弹窗
    closeComponent() {
      if (this.tableLoading) {
        return
      }
      this.$emit('closeComponent', 'AddDeviceModel')
    },
  },
  data() {
    return {
      systemParams: localStorage.getItem('systemParams')
        ? JSON.parse(localStorage.getItem('systemParams'))
        : [],
      userInfo: Wiz.AuthHooks.GetUserInfo(),
      currentMaterialFile: {}, // 模型贴图文件信息
      pos: [],
      showLoadProgress: false,
      loadPercentage: 0,
      loadType: '',
      fileId: [],
      currentModelParams: {},
      modelParams: '', // 模型信息
      // 元件基本信息
      devicesInfo: {
        seqNo: '',
        type: '',
        name: '',
        pathName: '',
        modelFileList: [],
        textureFileList: [],
        thumbnailFileList: [],
        fileName: '',
        thumbnails: '',
        templateAttrSetList: [
          {
            attrValueList: [],
            attributeTemplate: {},
            tableName: '',
            templateId: '',
          },
        ],
      },
      dialogInfo: {},
      typeKeyWords: '',
      addType: 1,
      checkList: [],
      listData: [],
      currentFolderId: '',
      typeList: [],
      // 方位
      location: [
        {
          value: 'Z',
          label: '上方',
        },
        {
          value: 'ZN',
          label: '下方',
        },
        {
          value: 'YN',
          label: '前方',
        },
        {
          value: 'Y',
          label: '后方',
        },
        {
          value: 'XN',
          label: '左方',
        },
        {
          value: 'X',
          label: '右方',
        },
      ],
      localValue: 'YN',
    }
  },
}
</script>
<style lang="scss">

@import '../../css/select.scss';

</style>
<style lang="scss" scoped>

@import '../../css/index.scss';
/deep/.player_progress {
  position: fixed !important;
}
/deep/.el-checkbox__label {
  font-size: 12px !important;
}
#AddDeviceModel {
  color: #fff;
  z-index: 99;
  width: 468px;
  background-color: rgba(46, 107, 176, 0.5) !important;
  transition: left 0.3s;
  border-radius: 2px;
  right: 35px;
}
.form_body {
  margin-top: 10px;
  background: rgba(24, 41, 72, 0.5);
  color: #fff;
  width: 100%;
  height: calc(100% - 140px);
  overflow-y: auto;
  padding: 10px 5px;
  .card {
    width: 94px;
    height: 150px;
    background: none;
    border: none;
    margin: 10px 7px;
    /deep/.el-card__body {
      padding: 0 !important;
      background: none;
    }
    /deep/.el-checkbox__label {
      width: 60px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
  .card_img {
    img {
      width: 100%;
      height: 100%;
    }
    width: 90px;
    height: 120px;
    background-color: #383b3b !important;
  }
  .card_list {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
  }
  .card_text {
    display: flex;
    width: 100%;
    height: 30px;
    background: none;
    p {
      font-size: 12px;
      line-height: 30px;
      height: 30px;
      color: #fff;
      text-align: center;
    }
    .el-checkbox {
      margin: 5px 12px 0 8px;
      color: #fff;
    }
  }
}
.form_bottom {
  margin-top: 10px;
}

</style>
